/**
 * Snapshot of the production midterm tag (titles + Democratic share) used
 * only when the tag fetch returns nothing the map can read — local and
 * staging environments whose market ids differ from production. Live data
 * always wins; these rows never link anywhere (negative ids).
 */
const race = (id, title, democraticShare) => ({
  id: -id,
  title,
  slug: '',
  volume_play_money: 0,
  volume_real_money: 0,
  outcomes: [
    { id: -id * 10 - 1, title: 'Democratic Party', price: { OOM: democraticShare } },
    { id: -id * 10 - 2, title: 'Republican Party', price: { OOM: 1 - democraticShare } },
  ],
})

export const MOCK_MIDTERM_MARKETS = [
  race(1, 'Control of the US Senate after the 2026 Elections', 0.65),
  race(2, 'Control of the US House of Representatives after the 2026 Elections', 0.89),
  race(3, 'Nevada governor election winner', 0.6),
  race(4, "New Hampshire's Senate election winner", 0.86),
  race(5, "Maine's Senate election winner", 0.58),
  race(6, "North Carolina's 1st congressional district election winner", 0.77),
  race(7, "Iowa's 1st congressional district election winner", 0.9),
  race(8, "Iowa's 2nd congressional district election winner", 0.59),
  race(9, "Virginia's 1st congressional district election winner", 0.55),
  race(10, 'California governor election winner', 0.93),
  race(11, "Florida's 27th congressional district election winner", 0.34),
  race(12, "Michigan's 7th congressional district election winner", 0.69),
  race(13, "Texas' 35th congressional district election winner", 0.65),
  race(14, 'Michigan Governor election winner', 0.88),
  race(15, 'Arizona Governor election winner', 0.85),
  race(16, 'Georgia governor election winner', 0.57),
  race(17, "Florida's 25th congressional district election winner", 0.82),
  race(18, "Wisconsin's 1st congressional district election winner", 0.4),
  race(19, "Arizona's 1st congressional district election winner", 0.79),
  race(20, "New York's 17th congressional district election winner", 0.62),
  race(21, "Virginia's 2nd congressional district election winner", 0.84),
  race(22, "Ohio's 7th congressional district election winner", 0.83),
  race(23, "Texas' 34th congressional district election winner", 0.81),
  race(24, "New Jersey's 7th congressional district election winner", 0.85),
  race(25, 'Iowa governor election winner', 0.78),
  race(26, "Montana's 1st congressional district election winner", 0.42),
  race(27, "Iowa's 3rd congressional district election winner", 0.77),
  race(28, "Michigan's 4th congressional district election winner", 0.56),
  race(29, "Pennsylvania's 8th congressional district election winner", 0.73),
  race(30, "Texas's Senate election winner", 0.62),
  race(31, "Ohio's Senate election winner", 0.6),
  race(32, "Pennsylvania's 7th congressional district election winner", 0.82),
  race(33, "Michigan's Senate election winner", 0.69),
  race(34, "California's 22nd congressional district election winner", 0.83),
  race(35, "Iowa's Senate election winner", 0.38),
  race(36, "North Carolina's Senate election winner", 0.89),
  race(37, "Georgia's Senate election winner", 0.94),
  race(38, 'Wisconsin governor election winner', 0.81),
  race(39, "Colorado's 5th congressional district election winner", 0.3),
  race(40, "Colorado's 8th congressional district election winner", 0.82),
]
